import LinkPainel from 'app/Core/Components/LinkPainel/LinkPainel';
import React from 'react';

const RightSideLayout1 = ({ xappRouteParams }) => {
    return (
        <React.Fragment>
            <LinkPainel />
        </React.Fragment>
    );
};

export default RightSideLayout1;
